import script from "./EmojiTextarea.vue?vue&type=script&setup=true&lang=js"
export * from "./EmojiTextarea.vue?vue&type=script&setup=true&lang=js"

import "./EmojiTextarea.vue?vue&type=style&index=0&id=e3f5f6a6&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/duanju_admin_vue_live/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e3f5f6a6"]])

export default __exports__